import { useState, useEffect } from "react";
import api from "@/lib/api";

export default function PaymentMethods({ className = "" }) {
  const [methods, setMethods] = useState([]);

  useEffect(() => {
    api.get("/payments/methods").then(({ data }) => setMethods(data.methods || [])).catch(() => {});
  }, []);

  if (!methods.length) return null;

  return (
    <div data-testid="payment-methods" className={`flex flex-wrap items-center justify-center gap-2 ${className}`}>
      <span className="text-xs text-zinc-500 mr-1">Betaal veilig met</span>
      {methods.map((m) => (
        <span key={m.id} title={m.description} className="inline-flex h-7 items-center rounded-md border border-zinc-800 bg-white/95 px-1.5">
          {m.image ? (
            <img src={m.image} alt={m.description} className="h-4 w-auto" />
          ) : (
            <span className="text-[10px] font-medium text-zinc-800 px-1">{m.description}</span>
          )}
        </span>
      ))}
    </div>
  );
}
